import Statistics from "./Statistics";

export default function StatisticsWrapper() {
    return <Statistics />;
}
